import { AttributeBarcodeFormat, AttributeText } from "../Consts";

export const PropertyLabels = {
    value: { text: AttributeText.text, barcodeFormat: AttributeBarcodeFormat.text },
    size: { x: 'X, мм', y: 'Y, мм', width: 'Ширина, мм', height: 'Высота, мм', rotation: 'Поворот, град' },
    font: { family:'Название', size: 'Размер', color: 'Цвет', bold: 'Жирный', italic: 'Курсив', hAlign: 'По горизонтали', vAlign: 'По вертикали' },
    pattern: { name: 'Название шаблона', drawBorder: 'Прорисовка границы', onWholePage: 'Заполнять лист', mLeft: 'Слева', mRight: 'Справа', mTop: 'Сверху', mBottom: 'Снизу' },
    folders: { values: 'Значение',  placement: 'Расположение', size: 'Размеры', font: 'Шрифт' }
}